'use client'

import Link from 'next/link'

export type NotFoundPageProps = {
  title?: string
  message?: string
  homeHref?: string
  homeText?: string
}

export function NotFoundPage({
  title = '404 - Page Not Found',
  message = "The page you're looking for doesn't exist.",
  homeHref = '/',
  homeText = 'Go Home',
}: NotFoundPageProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen" style={{ backgroundColor: 'var(--background-default)' }}>
      <h1 className="text-4xl font-bold mb-4" style={{ color: 'var(--foreground-default)' }}>{title}</h1>
      <p className="mb-8" style={{ color: 'var(--foreground-muted)' }}>{message}</p>
      <Link 
        href={homeHref}
        className="px-4 py-2 rounded transition-colors hover:[background-color:var(--primary-hover)]"
        style={{ backgroundColor: 'var(--primary-default)', color: 'var(--primary-foreground)' }}
      >
        {homeText}
      </Link>
    </div>
  )
}

